<!--
 * @Description  : 学校参与情况-提供课后服务学校明细表, 服务时间(5+2)达标学校明细表, 课程安排(1+X)达标学校
 * @Author       : chenJunHui
 * @LastEditors: chenJunHui
 * @Date         : 2022-09-06 14:02:57
 * @LastEditTime: 2022-11-14 14:49:38
 * @FilePath     : \after_class_service\src\pages\cloudMap\proupTable\schoolPart.vue
-->
<template>
  <div class="indexs">
    <div class="tabs" v-if="!isSchool">
      <p :class="{ active: !tabActice }" @click="tabActice = false">
        教师参与明细
      </p>
      <!-- <p :class="{ active: tabActice }" @click="tabActice = true">
        各类课程教师参与明细
      </p> -->
    </div>
    <div class="tabs" v-show="isSchool">
      <p :class="{ active: !tabActice }" @click="tabActice = false">
        校内教师
      </p>
      <p :class="{ active: tabActice }" @click="tabActice = true">
        校外教师
      </p>
    </div>
    <div class="table">
      <div v-if="!isSchool">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          :border="true"
          :current-page.sync="currentPage"
          :header-cell-style="{ background: '#FAFAFA', color: '#7A8DA2' }"
          v-show="!tabActice"
        >
          <el-table-column
            prop="orga_name"
            label="学校名称"
            width="180"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="org_num"
            label="校内教师参与数"
            width="180"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="ext_org_num"
            label="聘用校外教师数"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="org_per"
            label="校内教师参与占比"
            align="center"
            :formatter="tofixed"
          >
          </el-table-column>
          <el-table-column
            prop="main_per"
            label="校内主科教师参与占比"
            align="center"
            :formatter="tofixed"
          >
          </el-table-column>
        </el-table>
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          :border="true"
          :current-page.sync="currentPage"
          :header-cell-style="{ background: '#FAFAFA', color: '#7A8DA2' }"
          v-show="tabActice"
        >
          <el-table-column
            prop="orga_name"
            label="教师姓名"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="orga_name"
            label="作业辅导答疑课是否完成排课"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="orga_name"
            label="报名学生数"
            align="center"
            width="100"
          ></el-table-column>
        </el-table>
      </div>
      <div v-if="isSchool">
        <el-table
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          :border="true"
          :current-page.sync="currentPage"
          :header-cell-style="{ background: '#FAFAFA', color: '#7A8DA2' }"
        >
          <el-table-column
            prop="teacher_name"
            label="教师姓名"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="orga_name"
            label="机构名称"
            align="center"
            v-if="tabActice"
          >
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        style="marginTop: 20px; textAlign: center"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import cloudMapApi from "@/api/cloudMapApi.js";
import { mapMutations, mapState } from "vuex";
export default {
  props: ["selectParmam"],
  components: {},
  computed: {
    ...mapState(["isSchool"]),
  },
  data() {
    return {
      selectParmams: {},
      tabActice: 0,
      tableData: [],
      total: 0,
      currentPage: 1,
      loading: false,
      orgType: sessionStorage.org_type, // 1:教育局, 2:学校, 8:机构
    };
  },
  created() {},
  watch: {
    selectParmam(n, o) {
      this.selectParmams = n;
      this.getData();
    },
  },
  mounted() {
    console.log(this.selectParmam, "this.selectParmams");
    this.selectParmams = this.selectParmam;
    this.getData();
  },
  methods: {
    tofixed(row, colum, cellValue) {
      if (cellValue != null) {
        return (cellValue * 100).toFixed(2) + "%";
      }
    },
    handleSizeChange(val) {
      this.selectParmams.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.selectParmams.pagenum = val;
      this.getData();
    },
    ...mapMutations(["updateLoadingStatus"]),
    async getData() {
      this.pageNum_1 = 1;
      console.log(this.orgType == '1' , !this.isSchool);
      if(this.orgType == '1' && !this.isSchool){
      this.selectParmams.topic = "校";
        this.getList_1();
      }else{
        this.selectParmams.topic = "";
        this.getList_2()
      }
    },
    async getList_1() {
      this.loading = true;
      try {
        let res = await cloudMapApi.teacherActorAll(this.selectParmams);
        this.tableData = res.data.rows;
        this.total = res.data.total;
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
        // this.updateLoadingStatus({ show: false });
      }
    },
    async getList_2(){
      this.loading = true;
      try {
        let res = await cloudMapApi.teacherActorDetail(this.selectParmams);
        this.tableData = res.data.rows;
        this.total = res.data.total;
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
        // this.updateLoadingStatus({ show: false });
      }
    }
  },
};
</script>
<style lang="less" scoped>
.indexs {
  .no_data {
    text-align: center;
    margin: 20px;
  }
  .header {
    width: 100%;
    height: 50px;
    background: #ffffff;
    font-size: 18px;
    line-height: 25px;
    font-weight: bold;
    color: #000000;
    padding: 14px 15px 11px;
  }
  .tabs {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 14px 15px 11px;
    overflow-x: auto;
    flex-wrap: nowrap;
    flex-shrink: 0;

    .tab {
      padding: 5px 15px;
      background: #eff7ff;
      border: 1px solid #beddff;
      border-radius: 24px;
      font-size: 14px;
      line-height: 20px;
      color: #0067da;
      margin-right: 10px;
      flex: 0 0 auto;
    }
  }
}
</style>
